export const AssetsViewTabsData = [{ label: 'item-details' }, { label: 'images' }];
